import { render, staticRenderFns } from "./rgtx.vue?vue&type=template&id=c64e1b08&scoped=true"
import script from "./rgtx.vue?vue&type=script&lang=js"
export * from "./rgtx.vue?vue&type=script&lang=js"
import style0 from "./rgtx.vue?vue&type=style&index=0&id=c64e1b08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64e1b08",
  null
  
)

export default component.exports